module.exports = "/images/78b2abe443691748e8d594de5f7ca78b.svg";